import template from './final_residual_count_commit_print.html';
import controller from './final_residual_count_commit_print.controller';
import './final_residual_count_commit_print.scss';

let printComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default printComponent;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/final_residual_count_commit/print/final_residual_count_commit_print.component.js